export default function FireSafetyTable(el, {
    activeClass = 'is-active',
}) {
    const filtersToggle = el.querySelector('form [type="button"]');
    const filterTriggers = [...el.querySelectorAll('form select')];
    const table = el.querySelector('table');
    const rows = [...table.querySelectorAll('tbody tr')];
    const reset = el.querySelector('form [type="reset"]');
    const [empty, prompt] = el.querySelectorAll('table ~ p');

    function dasherize(str) {
        return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
    }

    // Cache each row's filterable values so we don't hit the DOM on every pass
    const rowData = rows.map(row => ({
        row,
        values: filterTriggers.reduce((acc, t) => {
            const name = t.getAttribute('data-fst-filter');

            acc[name] = row.getAttribute(`data-fst-${dasherize(name)}`);

            return acc;
        }, {}),
    }));

    function getActiveFilters() {
        return filterTriggers.reduce((acc, t) => {
            if (t.value !== '') {
                acc[t.getAttribute('data-fst-filter')] = t.value;
            }

            return acc;
        }, {});
    }

    function apply() {
        const active = getActiveFilters();
        const names = Object.keys(active);
        const hasFilters = names.length > 0;

        const visible = rowData.filter(({ row, values }) => {
            const matches = names.every(n => values[n] === active[n]);

            row.hidden = !matches;

            return matches;
        });

        // Table stays hidden until at least one filter is selected
        table.hidden = !hasFilters || visible.length === 0;
        empty.hidden = !hasFilters || visible.length > 0;
        prompt.hidden = hasFilters;
    }

    filtersToggle.onclick = () => {
        el.classList.toggle(activeClass);
    };
    filterTriggers.forEach(t => {
        t.onchange = apply;
    });
    reset.onclick = () => {
        filterTriggers.forEach(t => { t.value = ''; });
        apply();
        table.parentElement = 0;
    };

    apply();
}
